export const HOME = '/'
// this is the default Universal Login page (which can show login or sign up
// depending on extraParams screen_hint config)
export const DEFAULT = '/login'
export const SIGN_UP = '/sign-up'
// since /login is taken by the default
export const LOGIN = '/account-login'
export const VERIFY_CODE = '/verify-code'
export const FORGOT_PASSWORD = '/account/forgot-password'
export const CREATE_NEW_PASSWORD = '/create-new-password'
